/*
 * AdminPage Messages
 *
 * This contains all the text for the AdminPage container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.AdminPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Admin Panel",
  },
  users: {
    id: `${scope}.users`,
    defaultMessage: "Users",
  },
  practices: {
    id: `${scope}.practices`,
    defaultMessage: "Practices",
  },
  agendas: {
    id: `${scope}.agendas`,
    defaultMessage: "Agendas",
  },
  orders: {
    id: `${scope}.orders`,
    defaultMessage: "Orders",
  },
});
